import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import Body from '../partials/Body';
import CardButtons from '../partials/CardButtons';
import CardLayout from '../partials/CardLayout';
import CardTags from '../partials/CardTags';
import EventDates from '../partials/EventDates';

import styles from '../../../styles/cards/tickets.module.scss';

const propTypes = {
    item: AppPropTypes.product,
    event: AppPropTypes.event,
    className: PropTypes.string,
};

const defaultProps = {
    item: null,
    event: null,
    className: null,
};

const TicketsCard = ({ item, event, className }) => {
    const { type, title = null, image = null, isOnline = null, film = null } = event || {};
    const {
        type: productType = null,
        name: productName = null,
        description: productDescription = null,
        price = null,
        amount = null,
        isBundle = false,
    } = item || {};
    const { title: filmTitle = null } = film || {};
    const { url: imageUrl = null } = image || {};
    const isForum = productType === 'forum';
    const isScreening = type === 'screening';
    const isEvent = productType !== 'forum' && type === 'event';
    const showVisual = !isBundle && image !== null && imageUrl !== null;
    const isShift72Bundle = isBundle && productType === 'shift72';
    const cardTitle = isShift72Bundle || isForum ? productName : title;

    return (
        <CardLayout
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isForum]: isForum,
                    [styles.isScreening]: isScreening,
                },
            ])}
            tags={<CardTags withOnline={isOnline} withFree={amount === 0} />}
            image={showVisual ? image : null}
            isWide
            buttons={
                <CardButtons>
                    {price !== null ? (
                        <div className={styles.price}>
                            {amount === 0 ? (
                                <FormattedMessage defaultMessage="Free" description="Tag label" />
                            ) : (
                                price
                            )}
                        </div>
                    ) : null}
                </CardButtons>
            }
        >
            <p className={classNames(styles.heading, styles.eventType)}>
                {isScreening ? (
                    <FormattedMessage
                        defaultMessage="Screening"
                        description="Entity type heading"
                    />
                ) : null}
                {isForum ? (
                    <FormattedMessage defaultMessage="Forum" description="Entity type heading" />
                ) : null}
                {isEvent ? (
                    <FormattedMessage defaultMessage="Event" description="Entity type heading" />
                ) : null}
            </p>

            <h2 className={styles.title}>{cardTitle}</h2>

            {!isForum ? <EventDates item={event} /> : null}

            {productDescription !== null ? (
                <Body className={styles.ticketInfo} body={productDescription} />
            ) : null}

            {isForum ? (
                <div className={styles.ticketInfo}>
                    <FormattedMessage
                        defaultMessage="This includes access to:"
                        description="Info label"
                    />{' '}
                    <div className={styles.info}>{title}</div>
                </div>
            ) : null}

            {filmTitle !== null && isBundle ? (
                <div className={styles.eventInfo}>
                    <FormattedMessage
                        defaultMessage="This bundle includes:"
                        description="Info label"
                    />{' '}
                    <div className={styles.info}>{filmTitle}</div>
                </div>
            ) : null}
        </CardLayout>
    );
};

TicketsCard.propTypes = propTypes;
TicketsCard.defaultProps = defaultProps;

export default TicketsCard;
